"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _image = require("@site/pattern-library-core/image");
var _contentItem = _interopRequireDefault(require("./content-item"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-c5wjbyh",
  vars: {
    "c5wjbyh-0": [({
      hidden
    }) => hidden ? 'none' : 'grid']
  }
});
const Images = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Images",
  class: "pl-ixpgu7p",
  vars: {
    "ixpgu7p-0": [({
      hasImage
    }) => hasImage ? 'auto' : '53vw']
  }
});
const ImageContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImageContainer",
  class: "pl-iaydzr1",
  vars: {
    "iaydzr1-5": [({
      isLoaded
    }) => isLoaded ? 1 : 0]
  }
});
const MobileImageContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MobileImageContainer",
  class: "pl-msv0385",
  vars: {
    "msv0385-1": [({
      isLoaded
    }) => isLoaded ? 1 : 0]
  }
});
const Image = /*#__PURE__*/(0, _react2.styled)(_image.LazyPicture)({
  name: "Image",
  class: "pl-i38e7in"
});

/**
 * TemplateItem Component.
 *
 * @param {Object} props React props
 * @param {String} props.desktopPreviewImage Template desktop device image
 * @param {String} props.mobilePreviewImage Template mobile device image
 * @param {Number} props.i Current template index
 * @param {Boolean} props.activeTemplate Current active template
 * @param {Function} props.setActiveTemplate Setter for active template
 * @returns {React.ReactElement} TemplateItem Component
 * @public
 */

function TemplateItem({
  desktopPreviewImage,
  mobilePreviewImage,
  i,
  animateIn,
  hidden,
  activeTemplate,
  setActiveTemplate,
  ...rest
}) {
  const {
    width
  } = (0, _patternLibraryUtils.useWindowSize)();
  const [isDesktopImage, setIsDesktopImage] = (0, _react.useState)(!animateIn);
  const [isMobileImage, setIsMobileImage] = (0, _react.useState)(!animateIn);
  const isActive = activeTemplate;
  const className = `animate ${isActive ? 'active' : 'passive'}`;
  return /*#__PURE__*/_react.default.createElement(Container, {
    "data-cy": "template-item",
    className: className,
    tabIndex: -1,
    onMouseEnter: () => width >= _patternLibraryUtils.size.tabletLg && setActiveTemplate(i),
    onMouseLeave: () => width >= _patternLibraryUtils.size.tabletLg && setActiveTemplate(null),
    onFocus: () => width >= _patternLibraryUtils.size.tabletLg && setActiveTemplate(i),
    onBlur: () => width >= _patternLibraryUtils.size.tabletLg && setActiveTemplate(null),
    hidden: hidden
  }, /*#__PURE__*/_react.default.createElement(Images, {
    hasImage: desktopPreviewImage?.url
  }, /*#__PURE__*/_react.default.createElement(ImageContainer, {
    "data-cy": "image-container",
    className: className,
    isLoaded: isDesktopImage
  }, desktopPreviewImage && /*#__PURE__*/_react.default.createElement(Image, {
    defaultSrc: desktopPreviewImage.url,
    onLoad: () => setIsDesktopImage(true),
    defaultAltText: desktopPreviewImage.altText,
    width: desktopPreviewImage.width,
    height: desktopPreviewImage.height
  })), /*#__PURE__*/_react.default.createElement(MobileImageContainer, {
    "data-cy": "mobile-image-container",
    className: "mobile-container",
    isLoaded: isMobileImage
  }, mobilePreviewImage && /*#__PURE__*/_react.default.createElement(Image, {
    defaultSrc: mobilePreviewImage.url,
    onLoad: () => setIsMobileImage(true),
    defaultAltText: mobilePreviewImage.altText,
    width: mobilePreviewImage.width,
    height: mobilePreviewImage.height
  }))), /*#__PURE__*/_react.default.createElement(_contentItem.default, rest));
}
var _default = exports.default = TemplateItem;
TemplateItem.propTypes = {
  desktopPreviewImage: _propTypes.default.object.isRequired,
  mobilePreviewImage: _propTypes.default.object.isRequired,
  i: _propTypes.default.number,
  animateIn: _propTypes.default.bool,
  activeTemplate: _propTypes.default.bool,
  hidden: _propTypes.default.bool,
  setActiveTemplate: _propTypes.default.func
};